import { colors } from '../../tokens';
export default {
  primary: {
    backgroundColor: colors.brand.primary,
    color: colors.white
  },
  "default": {
    backgroundColor: colors.grey[100],
    color: colors.grey[500]
  },
  success: {
    backgroundColor: colors.success,
    color: colors.white
  },
  warning: {
    backgroundColor: colors.warning,
    color: colors.white
  },
  error: {
    backgroundColor: colors.error,
    color: colors.white
  }
};